import React, { useContext } from 'react';
import { GableType } from '../../models/GableType';
import { DragServiceGable } from '../../services/CabinetService/DragServiceGable';
import { EditorContext } from '../EditorCommon/EditorContext';
import { HorizontalRuler } from './HorizontalRuler';


const minRulerLength = 1;
interface Stop {
    start: number;
    stop: number;
}

/**
 * Displays a set of rulers that matches the space between gables on a cabinet
 */
export function InterGableRulers(props: {
    y: number;
}) {

    const ec = useContext(EditorContext);

    const inf = ec.cabinetService.getGableInfo();
    const gables = ec.cabinet.interiorItems.filter(ii => {
        const product = ec.cabinetService.interior.getProduct(ii.productId);
        return DragServiceGable.acceptable(product.productSubGroup)
    });
    gables.sort((a, b) => a.position.x - b.position.x);

    let left = inf.left.type === GableType.Gable
        ? inf.left.position.x + inf.left.size.x
        : 0;
    let stops: Stop[] = [];
    for (let gable of gables) {
        stops.push({ start: left, stop: gable.position.x });
        const right = gable.position.x + gable.size.x;
        left = right;
    }
    const right = inf.right.type === GableType.Gable
        ? inf.right.position.x
        : ec.cabinet.width!;
    stops.push({ start: left, stop: right });

    stops = stops.filter(s => s.stop - s.start > minRulerLength);

    return (
        <g className="inter-gable-rulers">
            {stops.map((s, index) => (
                <HorizontalRuler length={s.stop - s.start} x={s.start} svgY={props.y} key={index} />
            ))
            }
        </g>
    );
}
